export default __webpack_public_path__ + "static/media/guadalajara.56aed988.png";